import { useTheme } from '@mui/material/styles';
import { useColumnVisibility } from './hooks/useColumnVisibility';
import type { ColumnDef, ColumnVisibilityOptions } from './types';

export interface HeaderRowProps<T> {
  columns: readonly ColumnDef<T>[];
  allSelected?: boolean;
  someSelected?: boolean;
  onSelectAll?: () => void;
  options?: ColumnVisibilityOptions;
}

export function HeaderRow<T>({
  columns,
  allSelected = false,
  someSelected = false,
  onSelectAll,
  options = {},
}: HeaderRowProps<T>) {
  const theme = useTheme();
  const { visibleColumns, gridTemplateColumns } = useColumnVisibility(columns, options);

  return (
    <div
      style={{
        height: '40px',
        display: 'grid',
        gridTemplateColumns,
        alignItems: 'center',
        padding: '0 8px',
        borderBottom: `1px solid ${theme.palette.table.borderColor}`,
        backgroundColor: 'transparent',
        fontWeight: 600,
        fontSize: '0.70rem',
        textTransform: 'uppercase',
        color: theme.palette.table.headerFontColor,
      }}
      role="row"
    >
      {visibleColumns.map((col) => (
        <div
          key={col.key}
          role="columnheader"
          style={{
            width: col.width === 'auto' ? undefined : col.width,
            textAlign: col.align || 'left',
            display: 'flex',
            justifyContent: col.align,
            alignItems: 'center',
            paddingLeft: 8,
          }}
        >
          {col.renderHeader
            ? col.renderHeader({ allSelected, someSelected, onSelectAll })
            : col.label}
        </div>
      ))}
    </div>
  );
}
